import styled from "styled-components";
import { Flex, Image, Text } from "rebass/styled-components";
import { useState, useEffect } from "react";

import { Button } from "MVVM/Components/Button";
import { TComp } from "MVVM/Views/Competitions/@types";
import { LoadingSpinner } from "MVVM/Components/Lottie";

export const COTDSubmitted = ({
  campaign,
  onClose,
}: {
  campaign: TComp;
  onClose: (dontShowAgain: boolean) => void;
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <Container borderColor={campaign.color}>
        <Flex
          style={{
            height: "100%",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "450px",
          }}
        >
          <LoadingSpinner height={30} width={30} />
        </Flex>
      </Container>
    );
  }

  return (
    <Container borderColor={campaign.color}>
      <ChampionBanner
        style={{
          backgroundImage: `linear-gradient(to bottom, transparent, var(--Gray-750, #1c2a34)), url(${campaign.images.carouselBackground})`,
          justifyContent: "center",
        }}
      >
        <CampaignImage src={campaign.images.campaign} />
      </ChampionBanner>
      <Flex
        style={{ padding: "12px 24px 24px", gap: "20px" }}
        flexDirection="column"
        mb={7}
      >
        <Flex flexDirection="column" textAlign="center" style={{ gap: "20px" }}>
          <Text color="ice" variant="text.titleSmall">
            Sweet, We Got Your Clips!
          </Text>
          <Text color="chalk" variant="text.paragraphMedium">
            You can click on the bottom left banner again to keep submitting
            more clips.
          </Text>
        </Flex>
        <StyledButton
          bgColor={campaign.color}
          onClick={() => onClose(false)}
          style={{ width: "100%", margin: "0 auto" }}
        >
          Got it!
        </StyledButton>
        <StyledText
          color={campaign.color}
          variant="text.paragraphMedium"
          onClick={() => {
            window.localStorage.setItem(
              `dont_show_cotd_${campaign.campaign}`,
              "true",
            );
            onClose(true);
          }}
        >
          Don't show me this again
        </StyledText>
      </Flex>
    </Container>
  );
};

const StyledText = styled(Text)<{ color: string }>`
  color: ${({ color }) => color};
  cursor: pointer;
  margin: auto;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 4px;
  }
`;

const CampaignImage = styled(Image)`
  width: 50%;
  height: auto;
  opacity: 0.5;
`;

const StyledButton = styled(Button)<{ bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ theme }) => theme.colors.ice};

  &:hover {
    background-color: ${({ bgColor }) => bgColor}dd;
  }
`;

const Container = styled(Flex)<{ borderColor: string }>`
  background-color: var(--Gray-750, #1c2a34);
  border-radius: 14px;
  border: ${({ borderColor }) => `1px solid ${borderColor}20`};
  box-shadow: ${({ borderColor }) => `0px 0px 16px 0px ${borderColor}60`};
  flex-direction: column;
  position: relative;
  text-align: center;
  width: 448px;
`;

const ChampionBanner = styled(Flex)`
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
  height: 225px;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
`;
